import { usePathname, useSearchParams } from 'next/navigation';

import { useQuery } from '@apollo/client/react';

import { graphql, type DocumentType } from '@/gql';

import { Or2Link } from '@/components/navigation/Or2Link';

import type { UploadingFile } from '../UploadingFileRow';

const UPLOADING_FILE_PARENT_QUERY = graphql(`
  query UploadingFileParent($parentId: ID!) {
    file(id: $parentId) {
      _id
      filename
    }
  }
`);

const UPLOADING_FILE_PARENT_CELL_FILES_FOR_OWNER_FRAGMENT = graphql(`
  fragment uploadingFileParentCellFilesForOwnerFields on FilesForOwner {
    owner {
      ... on Group {
        _id
        name
      }
      ... on Service {
        _id
        name
      }
    }
  }
`);

interface Props {
  file: UploadingFile;
  filesForOwner: DocumentType<
    typeof UPLOADING_FILE_PARENT_CELL_FILES_FOR_OWNER_FRAGMENT
  >;
}

export const UploadingFileParentCell = ({ file, filesForOwner }: Props) => {
  const pathname = usePathname();
  const searchParams = useSearchParams();

  const { data } = useQuery(UPLOADING_FILE_PARENT_QUERY, {
    variables: { parentId: file.parent ?? '' },
    skip: !file.parent,
    fetchPolicy: 'cache-and-network',
  });

  const pathnameWithoutFileId =
    pathname.endsWith('docs') ||
    pathname.endsWith('docs/') ||
    pathname.endsWith('resources') ||
    pathname.endsWith('docs/')
      ? pathname
      : pathname.substring(0, pathname.lastIndexOf('/'));

  if (!file.parent) {
    return (
      <Or2Link href={`${pathnameWithoutFileId}?${searchParams.toString()}`}>
        {filesForOwner.owner.name}
      </Or2Link>
    );
  }

  return (
    <Or2Link
      href={`${pathnameWithoutFileId}/${
        file.parent
      }?${searchParams.toString()}`}
    >
      {data?.file?.filename ?? ''}
    </Or2Link>
  );
};
